import { Box, DialogContent, Modal } from "@mui/material"
import {
  FocusContext,
  setFocus,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation"
import React, { useEffect, useRef, useState } from "react"
import { playerStore, usePlayList } from "src/store/PlayerStore"

import { useModalDismiss } from "../../../../hooks/use-modal-dismiss"
import { useTransitions } from "../../../../hooks/use-transitions"
import useTranslate from "../../../../hooks/use-translate"
import { hwScroll } from "../../../../utilities/common"
import { s } from "../../../../utilities/common"
import { theme, TI } from "../../../../utilities/theme"
import { DGText } from "../../../common/DGText"
import { GradientOverlay } from "../../../common/GradientOverlay/GradientOverlay"
import { PlayerUIFocusKeys } from "../../player-ui-focus-keys"
import { usePlayer } from "../../use-player"
import { useProgress } from "../../use-progress"

import { PlaylistItem } from "./components/PlaylistItem"

const me = "Playlistmodal"

export const PlaylistModal = () => {
  const open = playerStore((state) => state.trackSelectOpen)

  if (!open) return null
  return <Screen />
}

const Screen = () => {
  const content = playerStore((state) => state.content)
  const setOpen = playerStore((state) => state.setTrackSelectOpen)
  const trackId = playerStore((state) => state.trackId)
  const modalCtrl = playerStore((state) => state.setTrackSelectOpen)
  const setTrackId = playerStore((state) => state.setTrackId)
  const { seek } = useProgress()
  const { play, pause, paused } = usePlayer()

  const playList = usePlayList(content)
  const t = useTranslate()

  const { ref, focusKey } = useFocusable({
    isFocusBoundary: true,
  })

  useModalDismiss(() => {
    setOpen(false)
    setFocus(PlayerUIFocusKeys.TrackButton)
  })

  const scrollRef = useRef<HTMLElement>(null)

  const transition = useTransitions()
  const [smoothScroll, setSmoothScroll] = useState(false)
  useEffect(() => {
    setTimeout(() => setSmoothScroll(true), 200)
  }, [])

  return (
    <Modal
      open={true}
      sx={{
        zIndex: 1301,
        height: "100vh",
        width: "100vw",
        backgroundColor: theme.palette.primary.variant,
        display: "block",
        "& > *": { transition: "none !important" },
      }}
    >
      <DialogContent>
        <GradientOverlay type={"full"} />
        <Box
          ref={scrollRef}
          sx={{
            overflowY: "hidden",
            transition: smoothScroll ? transition : "none",
          }}
        >
          <Box
            sx={{
              width: s("993px"),
              ml: s("244px"),
              height: "auto",
            }}
          >
            <DGText
              tx={TI.Subheadline05tv}
              sx={{
                mt: s("140px"),
                mb: s("24px"),
                fontStyle: "normal",
                color: theme.palette.white.grey,
                textTransform: "uppercase",
              }}
            >
              {t(
                content?.__typename === "Album"
                  ? "player__tvos_tracklist_title"
                  : "player__tvos_performanceworklist_title",
              )}
            </DGText>
            <FocusContext.Provider value={focusKey}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  "& > :last-child": {
                    mb: s("140px"),
                  },
                }}
                ref={ref}
              >
                {playList &&
                  playList.map((trackSet) => (
                    <Box
                      key={"trackset" + trackSet.id}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {trackSet.composerTitle && (
                        <Box sx={{ mt: s("36px"), mb: s("49px") }}>
                          <DGText
                            tx={TI.Subheadline05tv}
                            sx={{
                              mb: s("10px"),
                              color: theme.palette.white[55],
                              textAlign: "center",
                            }}
                          >
                            {trackSet.composerTitle}
                          </DGText>
                          <DGText
                            tx={TI.Subheadline02tv}
                            sx={{
                              mb: s("48px"),
                              color: theme.palette.white.main,
                              textAlign: "center",
                            }}
                          >
                            {trackSet.title}
                          </DGText>
                        </Box>
                      )}
                      {trackSet.items &&
                        trackSet.items.map((item, i) => (
                          <PlaylistItem
                            index={i}
                            key={item.title}
                            me={me}
                            data={item}
                            paused={paused}
                            onFocus={({ top: y }, _, query) => {
                              if (query && query.noScroll) return
                              hwScroll({
                                scrollRef,
                                y,
                              })
                            }}
                            onPress={(id) => {
                              if (item.id === trackId) {
                                if (paused) play()
                                else pause()
                              }
                              if (trackId !== id)
                                seek({ step: 0, relative: false })
                              if (setTrackId) setTrackId(id)
                              modalCtrl(false)
                              setFocus(PlayerUIFocusKeys.TrackButton)
                            }}
                            selected={item.id === trackId}
                          />
                        ))}
                    </Box>
                  ))}
              </Box>
            </FocusContext.Provider>
          </Box>
        </Box>
      </DialogContent>
    </Modal>
  )
}
